function NotFoundPage({message}) {
    return (
        <h2 className={'loading-page not-found'}>{message}</h2>
    )
}

export default NotFoundPage;